import useFormatDateFilterDate from "./useFormatDateFilterDate";
import isValidDate from "ui/common/components/input/DatePickerCalendar/utils/isValidDate";
import useSearchParamGroup from "ui/common/hooks/useSearchParamGroup";

export enum DateRangeFieldsNames {
    START_DATE = "startDate",
    END_DATE = "endDate",
    PAGE_FILTER = "pageFilter",
}

export default function useDateRangeFilterFields(): Parameters<typeof useSearchParamGroup> {
    const { parseDate } = useFormatDateFilterDate();

    function validation(value: string) {
        return isValidDate(parseDate(value));
    }

    return [
        [DateRangeFieldsNames.START_DATE, { validation }],
        [DateRangeFieldsNames.END_DATE, { validation }],
        [DateRangeFieldsNames.PAGE_FILTER, {}],
    ];
}
